import { NextPage } from 'next';
import { getUser } from 'common/api/user';
import { getUserGeotarget } from 'utils/user';
import { fetchEditorialTaxonomyDetails } from '../../actions/editorialTaxonomyDetails';
import {
  fetchEditorialTaxonomyPosts,
  resetEditorialTaxonomyPosts,
} from '../../actions/editorialTaxonomyPosts';
import EditorialTaxonomy from '../../containers/EditorialTaxonomy';
import { getOrCreateStore } from '../../stores';
import { WavetrakContext } from '../../types/wavetrak';

const SeriesPage: NextPage = () => <EditorialTaxonomy />;

SeriesPage.getInitialProps = async (context: WavetrakContext) => {
  const isServer = !!context.req;
  const user = await getUser(context, isServer);
  const countryCode = getUserGeotarget(user);
  const { dispatch, getState } = getOrCreateStore();
  const { terms } = context.query;
  const taxonomy = 'series';
  const term = terms?.[0] ?? null;
  const subCategory = terms?.[1] ?? null;
  await dispatch(resetEditorialTaxonomyPosts());
  await dispatch(fetchEditorialTaxonomyDetails(taxonomy, term, subCategory, countryCode, isServer));
  await dispatch(fetchEditorialTaxonomyPosts(taxonomy, term, subCategory, countryCode, isServer));

  if (isServer) {
    return {
      ssrReduxState: getState(),
    };
  }

  return {};
};

export default SeriesPage;
